import axios from "axios";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import { AppRoot } from "@telegram-apps/telegram-ui";
import { Toaster } from "react-hot-toast";

import { AppRoot as AppRootLocal } from "@/modules/telegram-ui-custom/components/Service/AppRoot/AppRoot";
import store from "@/store";
import { queryClient } from "@/config/configure-react-query";
import { initializeTelegramWebApp } from "@/config/initialize-telegram-web-app";
// import { initSentry } from "@/config/sentry";

import Router from "./router";
import "./assets/styles/global.scss";

if (import.meta.env.DEV) {
  axios.defaults.baseURL = "/api";
} else {
  axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;
}

// initSentry();

initializeTelegramWebApp({ patchTonConnectOpen: true });

createRoot(document.getElementById("root")!).render(
  <AppRoot>
    <AppRootLocal>
      <Toaster toastOptions={{ className: "the-toaster", duration: 2_000 }} />
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <TonConnectUIProvider
            manifestUrl={import.meta.env.VITE_TON_CONNECT_MANIFEST_URL}
            actionsConfiguration={{
              twaReturnUrl: `https://t.me/repcoinbot/rep?startapp=back`,
            }}
          >
            <Router />
          </TonConnectUIProvider>
        </QueryClientProvider>
      </Provider>
    </AppRootLocal>
  </AppRoot>,
);
